import { render } from "./Accordion.vue?vue&type=template&id=72c25604&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=72c25604&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c25604"]])

export default __exports__